/*
 * home (page)
 */
import { appConfig } from "@emr/config"
import {
	Badge,
	ButtonLink,
	Card,
	CardContent,
	CardHeader,
	CardTitle,
	Container,
	Page,
} from "@emr/react-ui"
import { createFileRoute } from "@tanstack/react-router"
import { BookOpen, Bot, ShieldCheck } from "lucide-react"
import { authPageLoaderSoft } from "../utils/auth.utils"

export const Route = createFileRoute("/")({
	component: HomePage,
	loader: authPageLoaderSoft({
		allowUnauthenticated: true,
		redirectAuthorized: appConfig.redirects.afterSignInUrl,
	}),
})

const features = [
	{
		icon: BookOpen,
		title: "Book appointments",
		description:
			"Easily book appointments online with your healthcare provider.",
	},
	{
		icon: ShieldCheck,
		title: "Tools Built for Wellbeing",
		description:
			"Track your symptoms and progress over time that can be shared with your healthcare provider.",
	},
]

function HomePage() {
	const { authenticated } = Route.useLoaderData()
	const waitlistHref = authenticated ? "/waitlist" : "/auth?tab=register"

	return (
		<Page centerVertical={false}>
			<Container width={"xxxl"} padding={"lg"} gap={"lg"}>
				{/* Hero */}
				<section
					className={
						"w-full flex flex-col items-center py-24 px-4 gap-6 text-center"
					}
				>
					<Badge variant={"outline"} className={"text-sm px-4 py-1"}>
						Early Access
					</Badge>
					<h1 className={"text-5xl font-bold tracking-tight max-w-2xl"}>
						Your health matters.
					</h1>
					<p className={"text-muted-foreground text-lg max-w-xl"}>
						Built for people who need easy access to their health information
						and tools to support their
					</p>
					<div className={"flex flex-col sm:flex-row gap-3 mt-2"}>
						<ButtonLink to={waitlistHref} size={"lg"}>
							Get Early Access
						</ButtonLink>
					</div>
				</section>
				<section className={"w-full flex justify-center px-4 pb-24"}>
					<div className={"grid grid-cols-1 sm:grid-cols-2 gap-6"}>
						{features.map(({ icon: Icon, title, description }) => (
							<Card key={title} className={"bg-background/60 backdrop-blur-sm"}>
								<CardHeader className={"gap-3"}>
									<div
										className={
											"w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center"
										}
									>
										<Icon className={"w-5 h-5 text-primary"} />
									</div>
									<CardTitle className={"text-base"}>{title}</CardTitle>
								</CardHeader>
								<CardContent>
									<p className={"text-sm text-muted-foreground"}>
										{description}
									</p>
								</CardContent>
							</Card>
						))}
					</div>
				</section>
			</Container>
		</Page>
	)
}
